import moment from 'moment';
import type { DateType } from 'vis-timeline';
import { Task, WayPoint, TaskTypeId } from '@bringg/types';
import type { ExtendedTimelineItem } from '@bringg-frontend/gantt-timeline';
import type { NotificationsTranslation } from '../translations';
import type { GanttItemCustomData } from '../../types';
import type { RoutesPlannerTask } from '../../../types';

const isInTimeRange = (start: string, noEarlierThan: string, end: string, noLaterThan: string): boolean => {
	return start >= noEarlierThan && end <= noLaterThan;
};
export const isTimelineItemInTimeWindowRange = (
	item: ExtendedTimelineItem,
	currentStart: string,
	currentEnd: string
): boolean => {
	const { noEarlierThan, noLaterThan } = item.customData as GanttItemCustomData;
	if (noEarlierThan && noLaterThan) {
		return isInTimeRange(currentStart, noEarlierThan, currentEnd, noLaterThan);
	}
	return true;
};

export const isTaskInTimeWindowRange = (task: RoutesPlannerTask, currentStart: Date, currentEnd: Date): boolean => {
	const noEarlierThan =
		task.way_points[0].no_earlier_than || task.way_points[0].first_attempt_promise_no_earlier_than;
	const noLaterThan = task.way_points[0].no_later_than || task.way_points[0].first_attempt_promise_no_later_than;

	return isInTimeRange(currentStart.toISOString(), noEarlierThan, currentEnd.toISOString(), noLaterThan);
};

export const isLate = (wayPoint: WayPoint) => {
	if (wayPoint.eta && wayPoint.no_later_than) {
		return new Date(wayPoint.eta).getTime() > new Date(wayPoint.no_later_than).getTime();
	}

	return false;
};

export const getChangedLinkedTasksByTimeError = (
	changedItem: ExtendedTimelineItem,
	changedTask: Task,
	linkedTaskStart: DateType | undefined,
	notificationsTranslations: NotificationsTranslation
) => {
	if (linkedTaskStart) {
		if (changedTask.task_type_id === TaskTypeId.PICKUP && !moment(changedItem.start).isBefore(linkedTaskStart)) {
			return { success: false, message: notificationsTranslations.collectionAfterDeliveryError };
		} else if (
			changedTask.task_type_id === TaskTypeId.DELIVERY &&
			!moment(changedItem.start).isAfter(linkedTaskStart)
		) {
			return { success: false, message: notificationsTranslations.deliveryBeforeCollectionError };
		}
	}
	return { success: true };
};
